import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { pxToRem, color, captions } from '../../utils'
import { incompatibilityAnalysisActions } from '../../actions'
import { Button } from '../../components/Form'
import Header from '../../components/Header'
import Sidebar from '../../components/Sidebar'
import Confirm from '../../components/Confirm'
import CabinetModal from '../../components/Cabinet/CabinetModal'
import ResponsiblesContent from '../../components/ResponsiblesContent'
import Can from '../../components/Can'
import { Grid, Content } from '../../components/Layout'
import { ButtonLoader } from '../../components/Cabinet'
import { SimpleLoader, WrapperLoader } from '../../components/loaders'
import ContentHeader from './ContentHeader'
import CabinetSearch from './CabinetSearch'
import CabinetsProduct from './CabinetsProduct'
import Cabinet from './Cabinet'
import Modal from '../../components/Modal'
import CaptionsArea from '../../components/Captions'

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  min-width: 100%;
  overflow-y: hidden;
  display: flex;
  scroll-snap-type: x mandatory;
`

const CabinetProducts = styled.div`
  max-height: ${pxToRem(385)};
  overflow-y: auto;
`

const AddCabinetButton = styled(Button)`
  margin-top: ${pxToRem(10)};
  max-width: ${pxToRem(300)};
  min-width: ${pxToRem(260)};
  height: ${pxToRem(38)};
  flex: 1;
  flex-shrink: 0;
  scroll-snap-align: center;
  border-radius: ${pxToRem('7px')};
  position: relative;
  font-size: ${pxToRem(13)};
`

const CabinetPlaceholder = styled.p`
  text-align: center;
  color: #858585;
  font-size: ${pxToRem(16)};
`

const CabinetsEmpty = styled.div`
  color: #5b666d;
  min-height: ${pxToRem(240)};
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  div {
    text-align: center;
  }
  strong {
    font-size: ${pxToRem(14)};
    text-align: center;
  }
`

const ReloadButton = styled(Button)`
  background: transparent;
  font-size: ${pxToRem(12)};
  padding: ${pxToRem(8)} ${pxToRem(15)};
  display: flex;
  border-color: ${color.primary};
  color: ${color.primary};
  align-items: center;
  justify-content: center;
  font-weight: bold;
  margin: ${pxToRem(15)} auto ${pxToRem(10)};
  svg {
    margin-left: ${pxToRem(10)};
  }
`

class IncompatibilityAnalysis extends Component {
  constructor(props) {
    super(props)
    this.state = {
      debounce: undefined,
      confirmOpen: false,
      confirmText: '',
      confirmCallback: undefined,
      modalError: undefined,
      modalErrorText: undefined,
      modalCabinetOpen: false,
      cabinet: null
    }
  }

  componentDidMount() {
    this.props.fetchCabinets({ areaId: this.props.areaId })
  }

  componentDidUpdate(prevProps) {
    if (prevProps.areaId !== this.props.areaId) {
      this.props.fetchCabinets({ areaId: this.props.areaId })
    }
  }

  showError = (message, text) => {
    this.setState({
      confirmOpen: true,
      modalError: message,
      modalErrorText: text
    })
  }

  searchCabinetProduct = ({ areaId, term, cabinetId }) => {
    return new Promise((resolve, reject) => {
      const debounce = setTimeout(() => {
        this.props
          .searchCabinetProduct({ areaId, term, cabinetId })
          .then(items => {
            resolve(items)
          })
          .catch(err => {
            reject(err)
          })
      }, 400)

      this.setState(state => {
        clearTimeout(state.debounce)
        return { debounce }
      })
    })
  }

  downloadPdf = (cabinetId) => {
    this.props.fetchDownloadPdf(this.props.areaId, cabinetId)
  }

  printQrCode = (id, name) => {
    this.props.fetchCabinetQrCode(id, name)
  }

  render() {
    const { searchCabinetProduct, showError, downloadPdf, printQrCode } = this

    const {
      cabinets,
      last_update,
      menuItems = [],
      router,
      cabinetSelectInputChange,
      addCabinetProduct,
      loadingCabinets,
      loadingCabinet,
      loadingDownload,
      loadingQrCode,
      removeCabinet,
      removeCabinetProduct,
      fetch_errors = false,
      fetchCabinets,
      areaId,
      changeStatusDownloadError
    } = this.props

    const {
      confirmText,
      confirmOpen,
      confirmCallback,
      modalError,
      modalErrorText,
      modalCabinetOpen,
      cabinet
    } = this.state

    return (
      <Fragment>
        <Grid>
          <Header router={router} />
          <Sidebar menuItems={menuItems} router={router} />

          <Content>
            <ContentHeader lastUpdate={last_update} areaId={areaId} />

            {areaId !== 'all' ? (
              <Fragment>
                {!fetch_errors.cabinet ? (
                  <Fragment>
                    {loadingCabinets ? (
                      <WrapperLoader>
                        <SimpleLoader />
                      </WrapperLoader>
                    ) : (
                      <Fragment>
                        {(cabinets || []).length ? (
                          <div>
                            <CaptionsArea />
                            <Wrapper id="CabinetsContainer">
                              {cabinets.map((item, index) => (
                                <Cabinet
                                  title={item.name}
                                  key={index}
                                  editPermission={'incompatibility-analysis-edit'}
                                  closePermission={'incompatibility-analysis-edit'}
                                  closeButtonAction={() => {
                                    this.setState({
                                      confirmOpen: true,
                                      confirmText: `Confirma a exclusão deste armário?`,
                                      confirmCallback: () => {
                                        removeCabinet({ areaId, cabinetId: item.id })
                                          .then(() => {
                                            this.setState({
                                              confirmOpen: false
                                            })
                                          })
                                          .catch(err => {
                                            showError('Falha ao excluir')
                                          })
                                      }
                                    })
                                  }}
                                  editButtonAction={() => {
                                    this.setState({
                                      modalCabinetOpen: true,
                                      cabinet: item
                                    })
                                  }}
                                  exportButtonAction={e => downloadPdf(item.id)}
                                  qrCodePrintButtonAction={() => printQrCode(item.id, item.name)}
                                >
                                  {!!item.loading && (
                                    <SimpleLoader pace />
                                  )}

                                  <Can functionality={'incompatibility-analysis-edit'}>
                                    <CabinetSearch
                                      value={''}
                                      onInputChange={value => {
                                        cabinetSelectInputChange(value, item.id)
                                      }}
                                      onChange={option => {
                                        if (!Array.isArray(option)) {
                                          addCabinetProduct({
                                            areaId,
                                            productId: option.value,
                                            cabinetId: item.id
                                          })
                                        }
                                      }}
                                      loadOptions={term => {
                                        return searchCabinetProduct({
                                          areaId,
                                          term,
                                          cabinetId: item.id
                                        })
                                      }}

                                    />
                                  </Can>

                                  <CabinetProducts>
                                    {item.cabinet_products.length ? (
                                      <Fragment>
                                        {(item.cabinet_products || []).map((item, index) => (
                                          <CabinetsProduct
                                            key={index}
                                            productTitle={item.product_name}
                                            productSupervisoriesCode={item.supervisories_code}
                                            productProvider={item.product_provider}
                                            removeButtonFunctionality={
                                              'incompatibility-analysis-edit'
                                            }
                                            buttonAction={() => {
                                              this.setState({
                                                confirmOpen: true,
                                                confirmText: `Confirma a exclusão do item: ${item.product_name}`,
                                                confirmCallback: () => {
                                                  removeCabinetProduct({
                                                    areaId,
                                                    productId: item.id,
                                                    cabinetId: item.cabinet_id
                                                  })
                                                    .then(() => {
                                                      this.setState({
                                                        confirmOpen: false
                                                      })
                                                    })
                                                    .catch(err => {
                                                      showError('Falha ao excluir')
                                                    })
                                                }
                                              })
                                            }}
                                          />
                                        ))}
                                      </Fragment>
                                    ) : (
                                      <CabinetPlaceholder>
                                        Não há produtos neste armário
                                      </CabinetPlaceholder>
                                    )}
                                  </CabinetProducts>
                                </Cabinet>
                              ))}

                              <Can functionality={'incompatibility-analysis-edit'}>
                                <AddCabinetButton
                                  disabled={loadingCabinet}
                                  onClick={() => {
                                    this.setState({
                                      modalCabinetOpen: true
                                    })
                                  }}
                                >
                                  {loadingCabinet ? (
                                    <ButtonLoader color={`#fff`} size={7} />
                                  ) : (
                                    <span>Adicionar armário</span>
                                  )}
                                </AddCabinetButton>
                              </Can>
                            </Wrapper>
                          </div>
                        ) : (
                          <CabinetsEmpty>
                            <div>
                              <strong>Nenhum armário nesta área.</strong>
                              <Can functionality={'incompatibility-analysis-edit'}>
                                <br />
                                <br />
                                <AddCabinetButton
                                  disabled={loadingCabinet}
                                  onClick={() => {
                                    this.setState({
                                      modalCabinetOpen: true
                                    })
                                  }}
                                >
                                  {loadingCabinet ? (
                                    <ButtonLoader color={`#fff`} size={7} />
                                  ) : (
                                    <span>Adicionar armário</span>
                                  )}
                                </AddCabinetButton>
                              </Can>
                            </div>
                          </CabinetsEmpty>
                        )}
                      </Fragment>
                    )}
                  </Fragment>
                ) : (
                  <CabinetsEmpty>
                    <div>
                      <strong>Falha ao carregar as informações.</strong>
                      <br />

                      <ReloadButton
                        onClick={() => {
                          fetchCabinets({ areaId })
                        }}
                      />
                    </div>
                  </CabinetsEmpty>
                )}
              </Fragment>
            ) : (
              <CabinetsEmpty>
                <div>
                  <strong>Você deve selecionar uma área para acessar esta funcionalidade.</strong>
                </div>
              </CabinetsEmpty>
            )}
            <ResponsiblesContent />
          </Content>
        </Grid>

        <Can functionality={'incompatibility-analysis-edit'}>
          <CabinetModal
            cabinet={cabinet}
            open={modalCabinetOpen}
            closeMethod={() => {
              this.setState({
                modalCabinetOpen: false,
                modalError: undefined,
                modalErrorText: undefined,
                cabinet: null
              })
            }}
            showError={showError}
            errorText={modalErrorText}
          />

          <Confirm
            title={modalError ? 'Erro' : 'Confirmação'}
            loading={false}
            error={modalError}
            errorText={modalErrorText}
            open={confirmOpen}
            closeMethod={() => {
              this.setState({
                confirmOpen: false,
                modalError: undefined,
                modalErrorText: undefined
              })
            }}
            callback={() => {
              confirmCallback()
            }}
          >
            <p>{confirmText}</p>
          </Confirm>
        </Can>
        <Modal
          title="Exportação PDF"
          open={loadingDownload}
          closeMethod={loadingDownload}
          size="small"
          loading={loadingDownload}
        />
        <Modal
          title="Gerar Qr Code"
          open={loadingQrCode}
          closeMethod={loadingQrCode}
          size="small"
          loading={loadingQrCode}
        />
        <Modal
          safeContent={false}
          loading={false}
          open={fetch_errors.download}
          size={'small'}
          error={true}
          errorMessage={'Falha ao exportar o arquivo'}
          closeMethod={changeStatusDownloadError}
        />
      </Fragment>
    )
  }
}

const mapStateToProps = state => ({
  loadingCabinets: state.incompatibilityAnalysis.loading.cabinets,
  loadingCabinet: state.incompatibilityAnalysis.loading.cabinet,
  loadingDownload: state.incompatibilityAnalysis.loading.download,
  loadingQrCode: state.incompatibilityAnalysis.loading.qr_code,
  cabinets: state.incompatibilityAnalysis.cabinets,
  last_update: state.incompatibilityAnalysis.last_update,
  fetch_errors: state.incompatibilityAnalysis.fetch_errors,
  areaId: state.auth.areaId
})

const mapDispatchToProps = dispatch => {
  return {
    removeCabinet: ({ areaId, cabinetId }) => {
      return dispatch(incompatibilityAnalysisActions.removeCabinet({ areaId, cabinetId }))
    },
    fetchCabinets: ({ areaId }) => {
      dispatch(incompatibilityAnalysisActions.fetchCabinets({ areaId }))
    },
    searchCabinetProduct: ({ areaId, term, cabinetId }) => {
      return dispatch(
        incompatibilityAnalysisActions.searchCabinetProduct({ areaId, term, cabinetId })
      )
    },
    addCabinetProduct: ({ areaId, productId, cabinetId }) => {
      dispatch(incompatibilityAnalysisActions.addCabinetProduct({ areaId, productId, cabinetId }))
    },
    removeCabinetProduct: ({ areaId, productId, cabinetId }) => {
      return dispatch(
        incompatibilityAnalysisActions.removeCabinetProduct({ areaId, productId, cabinetId })
      )
    },
    cabinetSelectInputChange: (value, cabinetId) => {
      dispatch(incompatibilityAnalysisActions.cabinetSelectInputChange(value, cabinetId))
    },
    fetchDownloadPdf: (areaId, cabinetId) => {
      dispatch(incompatibilityAnalysisActions.fetchDownloadPdf(areaId, cabinetId))
    },
    changeStatusDownloadError: () => {
      dispatch(incompatibilityAnalysisActions.changeStatusDownloadError())
    },
    fetchCabinetQrCode: (id, name) => {
      dispatch(incompatibilityAnalysisActions.fetchCabinetQrCode(id, name))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(IncompatibilityAnalysis)



// WEBPACK FOOTER //
// ./src/containers/IncompatibilityAnalysis/IncompatibilityAnalysis.js